// src/pages/admin/dashboard/tabs/transactions/index.jsx
import React from "react";
import TransactionTabs from "../../../../../components/transactions/TransactionTabs";
import CustomerTransactions from "./CustomerTransactions";
import StaffTransactions from "./StaffTransactions";
import { getTodaysTransactions, getAllTransactions } from "../../../../../services/api";

const Transactions = () => {

  const tabs = [
    { label: "Today's Transactions", api: getTodaysTransactions },
    { label: "All Transactions", api: getAllTransactions },

    // ✅ Replace API tabs with component tabs
    { label: "Staff All Transactions", component: <StaffTransactions type="all" /> },
    { label: "Staff Today's Transactions", component: <StaffTransactions type="today" /> },

    { label: "Customer Transactions", component: <CustomerTransactions /> },
  ];

  return (
    <div className="container-fluid">
      <h2>Transactions</h2>
      <TransactionTabs tabs={tabs} />
    </div>
  );
};

export default Transactions;
